import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import {
  CustomerRow,
  updateCustomer,
  UpdateCustomerResult,
} from "../../api/platformCustomers";

type Props = {
  customer: CustomerRow;
  onClose: () => void;
  onUpdated: (result: UpdateCustomerResult) => void;
};

export function EditCustomerModal({ customer, onClose, onUpdated }: Props) {
  const hasAdmin = Boolean(customer.admin_user_id);
  const [tenantName, setTenantName] = useState(customer.name);
  const [adminName, setAdminName] = useState(customer.admin_name || "");
  const [adminEmail, setAdminEmail] = useState(customer.admin_email || "");
  const [adminPhone, setAdminPhone] = useState(customer.admin_phone || "");
  const [branchAddress, setBranchAddress] = useState(customer.branch_address || "");
  const [isActive, setIsActive] = useState(customer.is_active);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await updateCustomer(customer.id, {
        tenantName: tenantName.trim(),
        adminName: hasAdmin ? adminName.trim() : undefined,
        adminEmail: hasAdmin ? adminEmail.trim() : undefined,
        adminPhone: adminPhone.trim() || undefined,
        branchAddress: branchAddress.trim() || undefined,
        isActive,
      });
      onUpdated(result);
    } catch (err: unknown) {
      setError(err instanceof ApiError ? err.message : "Musteri guncellenemedi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kp-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="kp-card kp-customer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kp-edit-customer-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="kp-customer-modal__head">
          <h3 id="kp-edit-customer-title">Müşteri Düzenle</h3>
          <button type="button" className="kp-btn kp-btn--ghost" onClick={onClose} disabled={busy}>
            Kapat
          </button>
        </div>

        <form className="kp-customer-modal__form" onSubmit={handleSubmit}>
          <label className="kp-customer-field">
            <span>
              Kurum adı (Kurs Adı) <em>*</em>
            </span>
            <input
              className="kp-input"
              value={tenantName}
              onChange={(e) => setTenantName(e.target.value)}
              required
              maxLength={150}
              disabled={busy}
            />
            <small className="kp-muted">Giriş ekranındaki Kurs Adı budur.</small>
          </label>

          {hasAdmin ? (
            <>
              <label className="kp-customer-field">
                <span>
                  Yönetici ad soyad <em>*</em>
                </span>
                <input
                  className="kp-input"
                  value={adminName}
                  onChange={(e) => setAdminName(e.target.value)}
                  required
                  maxLength={150}
                  disabled={busy}
                />
              </label>

              <label className="kp-customer-field">
                <span>
                  Yönetici e-posta <em>*</em>
                </span>
                <input
                  className="kp-input"
                  type="email"
                  value={adminEmail}
                  onChange={(e) => setAdminEmail(e.target.value)}
                  required
                  maxLength={150}
                  disabled={busy}
                />
              </label>

              <label className="kp-customer-field">
                <span>Telefon</span>
                <input
                  className="kp-input"
                  value={adminPhone}
                  onChange={(e) => setAdminPhone(e.target.value)}
                  maxLength={30}
                  disabled={busy}
                />
              </label>
            </>
          ) : (
            <p className="kp-muted">
              Bu kurumda aktif yönetici yok. Parola sıfırlama ve yönetici bilgisi düzenleme
              yapılamaz.
            </p>
          )}

          <label className="kp-customer-field">
            <span>Adres</span>
            <input
              className="kp-input"
              value={branchAddress}
              onChange={(e) => setBranchAddress(e.target.value)}
              maxLength={400}
              disabled={busy}
            />
          </label>

          <label className="kp-customer-field kp-customer-field--row">
            <input
              type="checkbox"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              disabled={busy}
            />
            <span>Kurum aktif</span>
          </label>

          {error && <div className="kp-customer-modal__error">{error}</div>}

          <div className="kp-customer-modal__actions">
            <button type="button" className="kp-btn" onClick={onClose} disabled={busy}>
              İptal
            </button>
            <button type="submit" className="kp-btn kp-btn--primary" disabled={busy}>
              {busy ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
